export default "__VITE_ASSET__8dc6af4e__"